export default __webpack_public_path__ + "static/screenshot-8d72d1b2bfdc83e5461de069908e1981.jpg";